import { html } from "src/components/HtmlViewer/utils";
import * as GQL from "src/types/graphql";

export const OFFER_EXTENDED = {
  type: GQL.message_template_type_enum.OfferExtended,
  emailSubject:
    "{{student.name}} received an offer from {{offer.schoolName}}! / ¡{{student.name}} recibió una oferta de {{offer.schoolName}}!",
  emailHtml: html`<p>
      Dear {{parent.name}},<br />
      <br />
      {{student.name}} received an offer from {{offer.schoolName}} for grade
      {{grade}} for the {{enrollmentPeriod.name}}!<br />
      <br />
      Please log in to accept or decline the offer: {{applyUrl}}<br />
      <br />
      If you need help, please contact {{organization.name}}.<br />
      <br />
      -{{organization.name}} Team<br />
    </p>
    <p>_____________________________________________</p>
    <p>
      Estimado/a {{parent.name}},<br />
      <br />
      {{student.name}} recibió una oferta de {{offer.schoolName}} para el grado
      {{grade}} para el {{enrollmentPeriod.name}}!<br />
      <br />
      Por favor, inicie sesión para aceptar o declinar la oferta:
      {{applyUrl}}<br />
      <br />
      Si necesita ayuda, por favor contacte a {{organization.name}}.<br />
      <br />
      -Equipo de {{organization.name}}<br />
    </p>`,
  emailText: `Dear {{parent.name}},

{{student.name}} received an offer from {{offer.schoolName}} for grade {{grade}} for the {{enrollmentPeriod.name}}!

Please log in to accept or decline the offer: {{applyUrl}}

If you need help, please contact {{organization.name}}.

-{{organization.name}} Team

_____________________________________________

Estimado/a {{parent.name}},

{{student.name}} recibió una oferta de {{offer.schoolName}} para el grado {{grade}} para el {{enrollmentPeriod.name}}!

Por favor, inicie sesión para aceptar o declinar la oferta: {{applyUrl}}

Si necesita ayuda, por favor contacte a {{organization.name}}.

-Equipo de {{organization.name}}`,
  sms: "{{student.name}} received an offer from {{offer.schoolName}}! Log in to accept/decline it / {{student.name}} recibió una oferta de {{offer.schoolName}}! Inicie sesión para aceptarla/declinarla. {{applyUrl}}",
};
